import React from "react";
import { Container, Typography, Box, Stack } from "@mui/material";
import { CONTACT } from "../../utils/constants";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 4,
        borderTop: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={1}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
        >
          <Box>
            <Typography sx={{ fontWeight: 800 }}>
              {CONTACT.brandName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {CONTACT.fullName} · {CONTACT.role}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2" color="text.secondary">
              {CONTACT.phoneDisplay} · {CONTACT.emails[0]}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} {CONTACT.brandName}. All rights
              reserved.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
